var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 127.3",
    style: {
      enableBackground: "new 0 0 128 127.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B90D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.4,123c1.1-10.4,1.4-13.7,1.2-20.6c0-0.6-0.3-1.7-0.7-2.2C49.2,93.9,41.8,88,36.5,86 c-0.5-0.2-2.4-0.3-2.7-0.1c-7,4-13.9,3.3-20.2-1.2c-10-7.1-11.2-21.9-2.7-30.8c0.8-0.8,0.7-1.4,0.4-2.3c-2.7-7-0.6-15.2,5-19.7 c2.8-2.2,6-3.2,9.5-3c0.9,0.1,1.3-0.2,1.7-1.1c3.1-7.6,9.3-11.5,17.4-11c1,0.1,1.3-0.5,1.7-1.2c2.9-5.5,7.2-9.4,13.4-10.7 c8.3-1.7,17,2.8,20.8,10.7c0.4,0.8,0.7,1.3,1.8,1.2c8-0.5,13.5,3.2,17.1,10.1c0.6,1.1,1.1,1.6,2.5,1.8c11,1.4,17.8,13.1,13,22.9 c-0.6,1.1,0,1.7,0.6,2.4c5.2,5.9,6.7,12.8,4.5,20.2c-2.2,7.4-7.4,11.8-14.9,13.6c-4.3,1-8.4,0.4-12.2-1.9c-2.3-1.6-8.9,2-9.3,2.4 c-5.1,3.6-6.4,5.2-9.2,9.5c-0.6,0.7-1.8,3.4-1.7,4.3c0.1,6,0.4,11.9,0.7,17.9c0,1,0.3,1.9,0.4,2.9C66.6,123,59.5,123,52.4,123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeicon);
export default __webpack_public_path__ + "static/media/Tree icon.9afb979b1be47f0fda161519bea71070.svg";
export { ForwardRef as ReactComponent };